{
    "(None)": "",
    "(save {highestYearlyDiscount}%)": "(экономия {highestYearlyDiscount}%)",
    "{amount} days free": "{amount} бесплатных дня(ей)",
    "{amount} off": "Скидка — {amount}",
    "{amount} off for first {number} months.": "Скидка — {amount} на первые {number} месяца(ев)",
    "{amount} off for first {period}.": "Скидка — {amount} на первый период: {period}",
    "{amount} off forever.": "Скидка — {amount} навсегда",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_few": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_many": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "Скидка — {discount}%",
    "{duration} membership": "",
    "{field}: {message}": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} больше не будет получать рассылку {newsletterName}.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} больше не будет получать электронные письма, когда кто-то отвечает на ваши комментарии.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} больше не будет получать эту рассылку.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} дня(ей) бесплатно",
    "{years} years": "",
    "+1 (123) 456-7890": "+7 (987) 654-3210",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Аккаунт",
    "Account details updated successfully": "Данные учётной записи успешно обновлены",
    "Account settings": "Настройки аккаунта",
    "Add a personal note": "Добавить личную заметку",
    "Add a short note to go with your gift": "",
    "Address line 1": "",
    "Address line 2": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "После окончания бесплатного периода с вас будут взиматься регулярные платежи по выбранному тарифу. До этого момента вы можете отменить подписку в любое время.",
    "Already a member?": "Уже есть аккаунт?",
    "An error occurred": "Упс! Произошла ошибка",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Произошла непредвиденная ошибка. Пожалуйста, повторите попытку или <a>обратитесь в службу поддержки</a>, если ошибка повторится.",
    "Back": "Назад",
    "Back to Log in": "Вернуться на страницу входа",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Чёрная пятница",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "Отменить подписку можно в любое время.",
    "Cancel subscription": "Отменить подписку",
    "Canceled": "",
    "Cancellation reason": "Поделитесь причиной отмены",
    "Change": "Изменить",
    "Change plan": "Сменить план",
    "Check spam & promotions folders": "Проверьте папки «Спам», «Рассылки» или «Промоакции»",
    "Check with your mail provider": "Обратитесь к своему почтовому провайдеру",
    "Check your inbox to verify email update": "Проверьте свой email, чтобы подтвердить обновление адреса электронной почты.",
    "Choose": "Выбрать",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Выбрать другой план",
    "Choose a plan": "Выберите план",
    "Choose a tier": "",
    "Choose an option": "",
    "Choose your newsletters": "Выбор и управление рассылками",
    "City": "",
    "Click here to retry": "Нажмите здесь, чтобы повторить попытку",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Закрыть",
    "Code": "Код",
    "Comment preferences updated.": "Настройки комментариев обновлены.",
    "Comments": "Комментарии",
    "Complimentary": "В благодарность",
    "Confirm": "Подтвердить",
    "Confirm cancellation": "Подтвердить отмену",
    "Confirm subscription": "Подтвердить подписку",
    "Contact support": "Написать в техподдержку",
    "Continue": "Продолжить",
    "Continue subscription": "Возобновить подписку",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "Не удалось создать сеанс оформления заказа через Stripe",
    "Could not sign in. Login link expired.": "Не удалось войти. Срок действия ссылки для входа истёк.",
    "Could not update email! Invalid link.": "Не удалось обновить email адрес! Неверная ссылка.",
    "Country": "",
    "Create a new contact": "Создать новый контакт",
    "Current plan": "Текущий план",
    "Delete account": "Удалить аккаунт",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Вы не хотели этого делать? Управляйте своими подписками <button>здесь</button>.",
    "Don't have an account?": "У вас нет аккаунта?",
    "Edit": "Редактировать",
    "Email": "Email",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "Email рассылки",
    "Email newsletter settings updated": "Настройки email рассылки обновлены",
    "Email preferences": "Настройки email адреса",
    "Email preferences updated.": "Настройки email адреса обновлены",
    "Emails": "Письма",
    "Emails disabled": "Доставка писем отключена",
    "Ends {offerEndDate}": "Предложение заканчивается {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "Введите свой email адрес",
    "Enter your name": "Введите ваше имя",
    "Error": "Ошибка",
    "Expires {expiryDate}": "Подписка заканчивается {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "Не удалось отменить подписку, попробуйте ещё раз",
    "Failed to log in, please try again": "Не удалось войти, попробуйте ещё раз",
    "Failed to log out, please try again": "Не удалось выйти, попробуйте ещё раз",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "Не удалось обработать заказ, попробуйте ещё раз",
    "Failed to send magic link email": "Не удалось отправить письмо с волшебной ссылкой",
    "Failed to send verification email": "Не удалось отправить письмо с подтверждением",
    "Failed to sign up, please try again": "Не удалось зарегистрироваться, попробуйте ещё раз",
    "Failed to update account data": "Не удалось обновить данные учётной записи",
    "Failed to update account details": "Не удалось обновить настройки учётной записи",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "Не удалось обновить настройки email рассылки",
    "Failed to update subscription, please try again": "Не удалось обновить подписку, попробуйте ещё раз",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "Навсегда",
    "Free Trial – Ends {trialEnd}": "Бесплатный период – заканчивается {trialEnd}",
    "From": "",
    "Get help": "Получить помощь",
    "Get in touch for help": "Свяжитесь с нами для получения помощи",
    "Get notified when someone replies to your comment": "Оповещать по email, когда кто-то отвечает на ваш комментарий",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Оставить отзыв на эту публикацию",
    "Help! I'm not receiving emails": "Помогите! Я не получаю электронные письма",
    "Here are a few other sites you may enjoy.": "Вот несколько других сайтов, которые могут вам понравиться.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Если рассылка помечена как спам, электронные письма перестают отправляться на этот адрес и автоматически отключаются, чтобы вы больше не получали нежелательных сообщений.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Если жалоба на спам была случайной или вы хотите снова получать рассылку, вы можете повторно подписаться на рассылку, нажав на кнопку «Подписаться повторно» на предыдущем экране.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Если вы отмените подписку сейчас, доступ к содержимому сохранится у вас до {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Если вы указали корпоративный или принадлежащий государственным органам адрес электронной почты, обратитесь в свой ИТ-отдел и попросите разрешить получать электронные письма от {senderEmail}.",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Ссылка для входа была отправлена вам на email. Если письмо не пришло в течение 3 минут, проверьте папку «Спам».",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "Письмо отправлено на адрес {submittedEmailOrInbox}. Нажмите на ссылку в письме или введите код ниже.",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Если вы хотите снова получать электронные письма, лучшим следующим шагом будет проверить ваш email адрес на наличие проблем, а затем нажать кнопку «Подписаться повторно» на предыдущем экране.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Если вы не получаете рассылку, на которую подписаны, вот несколько вещей, которые следует проверить.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Если вы выполнили все эти проверки, но по-прежнему не получаете электронные письма, вы можете обратиться за поддержкой по адресу: {supportAddress}.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "В случае возникновения постоянной ошибки при попытке отправки рассылки — электронные письма будут отключены для данной учётной записи и указанного email адреса.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "В вашем почтовом клиенте/приложении добавьте {senderEmail} в список контактов. Это скорее всего сигнализирует вашему почтовому провайдеру, что письмам, отправленным с этого адреса, следует доверять.",
    "Invalid email address": "Неправильный email адрес",
    "Invalid verification code": "",
    "Jamie Larson": "Павел Бид",
    "jamie@example.com": "paul@example.com",
    "Less like this": "Меньше подобного",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Убедитесь, что письма случайно не попадают в папки «Спам» или «Промоакции» вашего почтового ящика. Если это так, нажмите «Не спам!» и/или «Отметить как не спам» и/или «Переместить во входящие».",
    "Manage": "Управление",
    "Maybe later": "Может быть позже",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "В настоящее время для этого домена электронной подписки недоступны.",
    "Memberships unavailable, contact the owner for access.": "Подписки недоступны, свяжитесь с владельцем сайта для получения доступа.",
    "month": "месяц",
    "Monthly": "Ежемесячно",
    "More like this": "Больше подобного",
    "More options": "",
    "Name": "Имя",
    "Need more help? Contact support": "Нужна дополнительная помощь? Обратитесь в службу поддержки",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Рассылка могла быть отключена в вашей учётной записи (для вашего email адреса) по двум причинам: предыдущее электронное письмо было помечено как спам или попытка отправки приводила к постоянной ошибке (например: авто-возврату).",
    "No member exists with this e-mail address.": "Участника с таким email адресом не существует.",
    "No options found": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Не получаете письма?",
    "Now": "",
    "Now check your email!": "Теперь проверьте свою электронную почту!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Если после повторной подписки вы всё ещё не видите писем в своём почтовом ящике, проверьте папку со спамом. Некоторые провайдеры электронной почты сохраняют записи предыдущих жалоб на спам и продолжают помечать письма как спам. Если именно это и происходит, отметьте последнюю рассылку как «Не спам», чтобы переместить письмо обратно в основную папку входящих писем вашего почтового ящика.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Постоянный отказ (отскок/авто-возврат/bounce)",
    "Phone number": "Номер телефона",
    "Plan": "Обычный план",
    "Plan checkout was cancelled.": "Оплата плана подписки была отменена.",
    "Plan upgrade was cancelled.": "Апгрейд плана подписки был отменён.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Пожалуйста, свяжитесь с {supportAddress}, чтобы получить/настроить бесплатную подписку.",
    "Please enter {fieldName}": "Пожалуйста, введите {fieldName}",
    "Please fill in required fields": "Пожалуйста, заполните обязательные поля",
    "Podcasts": "",
    "Postal code": "",
    "Re-enable emails": "Подписаться повторно",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Рекомендации",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Remove {option}": "",
    "Renews at {price}.": "Продление за {price}.",
    "Resume subscription": "",
    "Retry": "Повторить попытку",
    "Save": "Сохранить",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Security verification": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Отправляем ссылку для входа...",
    "Sending...": "Отправка...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Показать все",
    "Sign in": "Войти",
    "Sign out": "Выйти",
    "Sign up": "Зарегистрироваться",
    "Signup error: Invalid link": "Ошибка регистрации: Неверная или просроченная ссылка",
    "Signups from this email domain are currently restricted.": "Регистрация почты с этого домена в настоящее время ограничена.",
    "Something went wrong, please try again later.": "Что-то пошло не так, попробуйте ещё раз позже.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "Извините, на данный момент рекомендации недоступны.",
    "Sorry, that didn’t work.": "Извините, это не сработало.",
    "Spam complaints": "Жалобы на спам",
    "Start {amount}-day free trial": "Начать {amount}-дневный пробный период",
    "Starting {startDate}": "Начиная с {startDate}",
    "Starting today": "Начиная с сегодняшего дня",
    "State": "",
    "Submit feedback": "Отправить отзыв",
    "Subscribe": "Подписки",
    "Subscribed": "Подписан",
    "Subscription plan updated successfully": "План подписки успешно обновлён",
    "Success": "Успех",
    "Success! Check your email for magic link to sign-in.": "Успех! Проверьте свою электронную почту на наличие волшебной ссылки для входа в систему.",
    "Success! Your account is fully activated, you now have access to all content.": "Успех! Ваша учётная запись полностью активирована, теперь у вас есть доступ ко всему содержимому.",
    "Success! Your email is updated.": "Успех! Ваш адрес электронной почты обновлён.",
    "Successfully unsubscribed": "Подписка успешно отменена",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Спасибо за подписку. Прежде чем вы начнёте читать, ниже приведены несколько других сайтов, которые вам могут понравиться.",
    "Thank you for your support": "Спасибо за вашу поддержку.",
    "Thank you for your support!": "Спасибо за вашу поддержку!",
    "Thanks for the feedback!": "Спасибо за отзыв!",
    "That didn't go to plan": "Что-то пошло не так",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Ваш email адрес: {memberEmail} — если он указан неправильно, вы можете обновить его в <button>области настроек учётной записи</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Возникла проблема с отправкой отзыва. Попробуйте ещё раз немного позже.",
    "There was an error cancelling your subscription, please try again.": "Произошла ошибка при отмене подписки. Попробуйте ещё раз.",
    "There was an error continuing your subscription, please try again.": "Произошла ошибка при продлении подписки. Попробуйте ещё раз.",
    "There was an error processing your payment. Please try again.": "Произошла ошибка при обработке вашего платежа. Попробуйте ещё раз.",
    "There was an error sending the email, please try again": "Произошла ошибка при отправке письма. Попробуйте ещё раз.",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Доступ к материалам этого сайта возможен только по приглашению. Для получения доступа свяжитесь с владельцем сайта.",
    "This site is not accepting donations at the moment.": "В данный момент сайт не принимает пожертвования.",
    "This site is not accepting payments at the moment.": "В данный момент сайт не принимает платежи.",
    "This site only accepts paid members.": "Этот сайт доступен только для платных участников.",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Чтобы завершить регистрацию, нажмите на ссылку подтверждения в электронном письме, которое мы прислали. Если письмо не пришло в течение 3 минут, проверьте папку «Спам»!",
    "To continue to stay up to date, subscribe to {publication} below.": "Чтобы оставаться в курсе событий, подпишитесь на {publication} ниже.",
    "Too many attempts try again in {number} days.": "Слишком много попыток. Повторите попытку через {number} д.",
    "Too many attempts try again in {number} hours.": "Слишком много попыток. Повторите попытку через {number} ч.",
    "Too many attempts try again in {number} minutes.": "Слишком много попыток. Повторите попытку через {number} мин.",
    "Too many different sign-in attempts, try again in {number} days": "Слишком много разных попыток входа, попробуйте ещё раз через {number} д.",
    "Too many different sign-in attempts, try again in {number} hours": "Слишком много разных попыток входа, попробуйте ещё раз через {number} ч.",
    "Too many different sign-in attempts, try again in {number} minutes": "Слишком много разных попыток входа, попробуйте ещё раз через {number} мин.",
    "Too many sign-up attempts, try again later": "Слишком много попыток регистрации, попробуйте зарегистрироваться немного позже",
    "Try free for {amount} days, then {originalPrice}.": "Попробуйте бесплатно в течение {amount} дня(ей), затем за {originalPrice}.",
    "Unable to initiate checkout session": "Невозможно начать сеанс оформления заказа",
    "Unable to verify your request, please try again": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Получите доступ ко всем рассылкам, оформив платную подписку.",
    "Unsubscribe from all emails": "Отписаться от всех рассылок",
    "Unsubscribed": "Отписан",
    "Unsubscribed from all emails.": "Отписан от всех рассылок.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Отписка от рассылки не отменит вашу платную подписку на {title}",
    "Update": "Обновить",
    "Update your preferences": "Обновить настройки",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Ссылка для подтверждения отправлена, проверьте свой почтовый ящик",
    "Verify your email address is correct": "Проверьте правильность вашего email адреса.",
    "Verifying...": "",
    "View plans": "Ознакомиться с планами",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Мы не смогли отписать вас, так как указанный email адрес не был найден. Пожалуйста, свяжитесь с владельцем сайта.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Добро пожаловать, {name}, с возвращением!",
    "Welcome back!": "Добро пожаловать, с возвращением!",
    "Welcome to {siteTitle}": "Добро пожаловать на {siteTitle}",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Когда почтовый ящик не принимает электронное письмо, это обычно называется отказом (bounce). Во многих случаях это может быть временным явлением. Но, в некоторых случаях возвращённое электронное письмо может быть возвращено со статусом постоянного отказа, такое происходит, когда адрес электронной почты недействителен или не существует.",
    "Why has my email been disabled?": "Почему моя электронная почта была отключена?",
    "X (Twitter)": "",
    "year": "год",
    "Yearly": "Ежегодно",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "В настоящее время у вас есть бесплатное членство, но для получения полного доступа к содержимому сайта — перейдите на платную подписку.",
    "You have been successfully resubscribed": "Вы успешно снова подписались на рассылку",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "В данный момент вы не получаете электронные письма",
    "You're not receiving emails": "Вы не получаете электронные письма",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Вы не получаете электронные письма, потому что: либо отметили одно из наших писем как спам, либо письма не могут быть доставлены на указанный вами email адрес.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_few": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_many": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_few": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_many": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "Вы успешно вошли.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Вы успешно подписались на <strong>{siteTitle}</strong>",
    "Your account": "Ваш аккаунт",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "Не удалось подписаться повторно используя ваш email, попробуйте ещё раз",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Ваш отзыв помогает формировать понимание, что вам интересно и что будет опубликовано в будущем.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Срок действия вашей подписки истекает {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Ваша подписка будет продлена {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Ваша подписка начнётся {subscriptionStart}"
}
